import axios from "axios";
import { BASE_URL_REPORTS } from "./apiConfig";
import { getToken, getStoreId } from "./helper";
import { handle401Error } from "./refreshHandler";

export const REPORT_API = axios.create({
  baseURL: BASE_URL_REPORTS,
  headers: { "Content-Type": "application/json", Accept: "application/json" },
});

REPORT_API.interceptors.request.use(config => {
  const token = getToken();
  if (token) config.headers["Authorization"] = `Bearer ${token}`;
  const storeId = getStoreId();
  if (storeId) config.headers.common["X-STORE"] = storeId;
  return config;
});

REPORT_API.interceptors.response.use(
  response => response,
  error => handle401Error(error, REPORT_API)
);
